import PlansInterceptor from '../PlansInterceptor'

const api = new PlansInterceptor()

export default {
  activeAssinatura(assinaturaId: String) {
    return api.post(`/assinaturas/${assinaturaId}/ativar`, null)
  },

  createAssinatura(plano: object): any {
    return api.post(`/assinaturas`, plano)
  },

  createAssinaturaComercial(assinatura: object): any {
    return api.post(`/assinaturas/comercial`, assinatura)
  },

  getAssinatura(showPrice?: Boolean) {
    return api.get(`/assinaturas?show_price=${showPrice || false}`)
  }
}
